module.exports = __webpack_public_path__ + "img/weather25.3edcf131.png";